import { promotionsSlice } from "./promotionsSlice";
import * as actions from "./promotionsActions";
import * as selectors from "./promotionsSelectors";

export { actions };
export { selectors };
export default promotionsSlice.reducer;
